// Layouts
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Pages
import Login from "@/pages/Dashboard/Pages/Login.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";
import ForgotPassword from "@/pages/Dashboard/Pages/EmailForgotPassword.vue";
import ResetPassword from "@/pages/Dashboard/Pages/ResetPassword.vue";
import Users from "@/pages/Users/Index.vue";
import CreateUser from "@/pages/Users/Create.vue";
import ViewUser from "@/pages/Users/View.vue";
import ProfileUser from "@/pages/Users/Profile.vue";
import NewsList from "@/pages/News/Index.vue";
import NewsCreateForm from "@/pages/News/CreateNewsPage.vue";
import NewsEditForm from "@/pages/News/EditNewsPage.vue";
import BoardMemberList from "@/pages/About/BoardMembers/Index.vue";
import CreateBoardMemberPage from "@/pages/About/BoardMembers/CreateBoardMemberPage.vue";
import EditBoardMemberPage from "@/pages/About/BoardMembers/EditBoardMemberPage.vue";
import AboutIndex from "@/pages/About/AboutUPM/Index.vue";
import MethodologyUniversityIndex from "@/pages/About/MethodologyUniversity/Index.vue";
import MethodologyProgramIndex from "@/pages/About/MethodologyProgram/Index.vue";

//University
import {
  universityPages,
  universityTemplatePages,
  criterionPages,
  criterionCategoryPages,
  universityDivisionPages,
  universityTypePages
} from "./routePages/university";

//program
import {
  programPages,
  programTemplatePages,
  programCriterionPages,
  programCriterionCategoryPages,
  programDivisionPages,
  programTypePages
} from "./routePages/program";

import i18n from "../lang/i18n";

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requireAuth: false,
        title: i18n.t("page_title.login")
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {
        requireAuth: false,
        title: i18n.t("page_title.forgot_pass")
      }
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPassword,
      meta: {
        requireAuth: false,
        title: i18n.t("page_title.reset_pass")
      }
    }
  ]
};

let userPages = {
  path: "/users",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "UsersList",
      components: { default: Users },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.user_list")
      }
    },
    {
      path: "add",
      name: "CreateUser",
      components: { default: CreateUser },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.user_create")
      }
    },
    {
      path: ":id/view",
      name: "ViewUser",
      components: { default: ViewUser },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.user_view")
      }
    },
    {
      path: "profile",
      name: "ProfileUser",
      components: { default: ProfileUser },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.my_profile")
      }
    }
  ]
};

let newsPages = {
  path: "/news",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "NewsList",
      components: { default: NewsList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.news_list")
      }
    },
    {
      path: "add",
      name: "NewsCreateForm",
      components: { default: NewsCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.news_create")
      }
    },
    {
      path: ":id/view",
      name: "NewsEditForm",
      components: { default: NewsEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.news_edit")
      }
    }
  ]
};

let boardMemberPages = {
  path: "/board-members",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "BoardMemberList",
      components: { default: BoardMemberList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.board_member_list")
      }
    },
    {
      path: "add",
      name: "CreateBoardMemberPage",
      components: { default: CreateBoardMemberPage },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.board_member_create")
      }
    },
    {
      path: ":id/view",
      name: "EditBoardMemberPage",
      components: { default: EditBoardMemberPage },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.board_member_edit")
      }
    }
  ]
};

let aboutPages = {
  path: "/about",
  component: DashboardLayout,
  children: [
    {
      path: "upm",
      name: "AboutIndex",
      components: { default: AboutIndex },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.manage_content_upm")
      }
    }
    // {
    //   path: "methodology-university",
    //   name: "MethodologyUniversityIndex",
    //   components: { default: MethodologyUniversityIndex },
    //   meta: {
    //     requireAuth: true,
    //     title: i18n.t("page_title.manage_methodology_university")
    //   }
    // },
    // {
    //   path: "methodology-program",
    //   name: "MethodologyProgramIndex",
    //   components: { default: MethodologyProgramIndex },
    //   meta: {
    //     requireAuth: true,
    //     title: i18n.t("page_title.manage_methodology_program")
    //   }
    // }
  ]
};

export const routes = [
  {
    path: "/",
    redirect: "/university",
    name: "Home",
    meta: {
      requireAuth: true,
      title: i18n.t("page_title.university_list")
    }
  },
  authPages,
  userPages,
  universityPages,
  universityTemplatePages,
  criterionPages,
  criterionCategoryPages,
  universityDivisionPages,
  universityTypePages,
  programPages,
  programTemplatePages,
  programCriterionPages,
  programCriterionCategoryPages,
  programDivisionPages,
  programTypePages,
  newsPages,
  boardMemberPages,
  aboutPages
];
